<template>
  <div v-if="isLoading" class="base-loading">
    <div class="base-loading__bar"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const isLoading = ref(false)

// Show loading when route changes start
router.beforeEach(() => {
  isLoading.value = true
})

// Hide loading when route changes complete
router.afterEach(() => {
  isLoading.value = false
})
</script>

<style lang="scss" scoped>
.base-loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  margin: 0;
  padding: 0;
  pointer-events: none;
}

.base-loading__bar {
  width: 100%;
  height: 3px;
  background: $sb-color-background-brand-primary;
  animation: loading 1s ease-in-out infinite;
}

@keyframes loading {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
